/** Ползунок на первой строке и точный числовой ввод на второй для ограниченных значений. */
import { NumberInput } from "./NumberInput";
import { Text } from "./Text";

export const RangeNumberInput = ({
	label,
	value,
	min,
	max,
	step = 10,
	onChange,
	error,
	unit = "мм",
}: {
	label: string;
	value: string;
	min: number;
	max: number;
	step?: number;
	onChange: (value: string) => void;
	error?: string;
	unit?: string;
}) => {
	const numericValue = Number(value);
	const rangeValue = Number.isFinite(numericValue)
		? Math.min(max, Math.max(min, numericValue))
		: min;

	return (
		<div className="flex min-w-0 flex-col gap-1.5">
			<Text className="text-xs font-medium text-muted">{label}</Text>
			<input
				type="range"
				aria-label={label}
				value={rangeValue}
				min={min}
				max={max}
				step={step}
				onChange={(event) => onChange(event.target.value)}
				className="h-1.5 w-full cursor-pointer accent-accent"
			/>
			<NumberInput
				ariaLabel={label}
				value={value}
				min={min}
				max={max}
				onChange={onChange}
				unit={unit}
			/>
			{error && <Text className="text-xs text-danger">{error}</Text>}
		</div>
	);
};
